type NewlyAddedPanel = {
	roofSegmentId: string;
	exteriorCoords: number[][];
	orientation: string;
}

type CurrentMovablePanel = {
	roofSegmentId: string;
	exteriorCoords: number[][];
	panelId: string;
	orientation: string;
	originSegmentId: string;
}

export enum OBS_SHAPE {
	RECT = 'RECT',
	CIRCLE = 'CIRCLE',
	POLYGON = 'POLYGON',
}

export enum OBS_EDIT_POINT_ACTION {
	ADD_POINT = 'add',
	DELETE_POINT = 'delete',
}

type ToolNewPostionSilce = {

	roofIndexes: string[] // editedRoofIds,
	selectedRoofIndex: string | null;
	selectedRoofAzimuth: number | null;
	deletedRoofIndexes: string[],
	newlyCreatedFacets: { [id: string]: NewlyCreatedFacet },
	editModeEnabled: boolean,
	threeDModelEnabled: boolean,
	saveWithPanelColor: boolean,
	userHasClickedSave: boolean,
	drawModeEnabled: boolean,
	isMouseOnMap: boolean,
	selectedUnfinalizedKonvaFacetId: string | null;
	deleteUnfinalizedFacet: boolean;
	zoomLevel:number;
	moveStage: boolean;
	rotateStage: boolean;
	stageRotation: number;
	konvaStagePosition: Vector2d;
	userHasModifiedRoofSegs: boolean,
	fullScreenEnabled:boolean;
	selectedProvider: ImagerySource;
	hadTransition: boolean
	deletedObstructionIDs: Array<string>;
	deleteObstructionsMode: boolean ;
	facetHistory: FacetHistory;
	currentActiveFacetEditMode: 'DRAW_MODE' | 'DELETE_OBSTRUCTION_MODE' | 'ADD_OBSTRUCTION_MODE' | undefined;
	deleteObstructionsPopUp: boolean;
	toggleGroundMountEnabled: boolean;
	groundMountEnabled: boolean;
	editShadingPerformed: boolean;
	toggleNoGapGroundMountEnabled: boolean,
	noGapGroundMountEnabled: boolean,
	enabledDevMode: boolean,
	azimuthEditedFacets: { [key:string]: boolean},
	invalidAzimuthFacets: { [key:string]: boolean},
	confirmedExceedingAzimuthFacets: string[],
	anyInvalidAzimuth: boolean,
	addObstructionsMode: boolean,
	addObstructionsPopUp: boolean,
	obstructionShape: OBS_SHAPE,
	manualObs: { [key:string]: Obstruction },
	showSetback: boolean;
	fullModePopupOpen: boolean;
	fullModePopupMessgage: string;
	showLinearFtForSolar: boolean;
	multiFingersPress: boolean;
	deleteFacetMode: boolean;
	fullViewSidePanel: boolean;
	fullViewSidePanelBeforeThreeD: boolean | null;
	threeDViewLoaded: boolean,
	isCancelModalOpen: boolean;
	drawnFacetExists: boolean;
	enableEditObs: boolean;
	editedObstructions: Record<string, EditedObstruction>;
	invalidObstructionIds: string[];
	drawnObsExists: boolean;
	selectedObstructionId: string | null;
	obstructionEditPointAction: OBS_EDIT_POINT_ACTION | null;
	isTransformingAzimuth: boolean;
	pendingAzimuthConfirmationFacet: string | null;
	guideMode: boolean;
	snapMode: boolean;
	hideSatelliteOverlay: boolean;
	activeDragFunctionality: string | null;
	mapOnlyFrozenPoint: { x: number; y: number } | null;
}

export interface EditedObstruction {
  id: string;
  coordinates: number[][];
  userMapped: boolean;
  area: number;
  assessment: 'RAW' | 'CIRCLE' | 'RAW_LARGE';
}

export type ToolHistory<T> = {
  currentIndex: number;
  history: T[];
};

type FacetHistory = { 
	obstruction: ToolHistory<{ deletedObstructionIDs: string[] }>;
  deleteFacet: ToolHistory<{ deletedRoofIndexes: string[] }>;
}

type NewlyCreatedFacet = {
	hullCoords: number[][],
	konvaPolygonId: string;
	azimuthDegrees?: number;
	pitchDegrees?: number | null;
	shading?: number;
	isGroundMount?: boolean;
	noGapGroundMount?: boolean;
	rowSpacing?: number;
	startingHeight?: number;
	isEdited?: boolean;
}

type NewlyCreatedFacetHullCoords = Omit<NewlyCreatedFacet, 'konvaPolygonId'>;

type DeletedPanel = {
	panelId: string;
	roofSegmentId: string;
}

export type {
	ToolNewPostionSilce,
	NewlyCreatedFacet,
	NewlyAddedPanel,
	NewlyCreatedFacetHullCoords,
	CurrentMovablePanel,
	DeletedPanel,
};
